const getLiveTradesEventName = (chain: string, base: string, quote: string) => {
  return `liveTrade_${chain}_${base}${quote}`;
};

export { getLiveTradesEventName };
